import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import classes from "./FrontendDataTable.module.css";

/**
 * A wrapper component for PrimeReact DataTable that handles frontend pagination and sorting
 * @param {Array} data - The data to display in the table
 * @param {Array} columns - Array of column definitions { field, header, body, sortable }
 * @param {number} defaultRows - Default number of rows per page
 * @param {Array} rowsPerPageOptions - Options for rows per page dropdown
 * @param {string} emptyMessage - Message to display when no data is available
 * @param {string} className - Additional class name for the table
 * @param {boolean} responsive - Whether to use responsive layout
 * @returns {JSX.Element} Datatable with frontend pagination and sorting
 */
const FrontendDataTable = ({
  data = [],
  columns = [],
  defaultRows = 10,
  rowsPerPageOptions = [5, 10, 25, 50],
  emptyMessage = "No data found",
  className = "",
  responsive = true,
}) => {
  // Pagination state
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(defaultRows);
  
  // Sorting state
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  
  // Handle pagination
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  
  // Handle sorting
  const onSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };
  
  return (
    <div className={classes.tableContainer}>
      <div className={classes.tableScroll}>
        <DataTable
          value={data}
          paginator
          rows={rows}
          rowsPerPageOptions={rowsPerPageOptions}
          totalRecords={data.length}
          lazy={false}
          first={first}
          onPage={onPageChange}
          onSort={onSort}
          sortField={sortField}
          sortOrder={sortOrder}
          emptyMessage={emptyMessage}
          className={`${classes.table} ${className}`}
          responsiveLayout="scroll"
          scrollable
          scrollHeight="flex"
        >
          {columns.map((col, i) => (
            <Column
              key={col.field || i}
              field={col.field}
              header={col.header}
              body={col.body}
              sortable={col.sortable}
              style={col.style}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default FrontendDataTable; 